export default "__VITE_ASSET__vTXL3J8Q__"